import styled from '@emotion/styled';

export const Page = styled.div`
`;
